var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DemoBase',[_vm._v(" Basic "),_c('DatePicker'),_vm._v(" Min & Max (+/- 3 days) "),_c('DatePicker',{attrs:{"placeholder":"Min & Max","min-date":_vm.min,"max-date":_vm.max}}),_vm._v(" Allow past pick "),_c('DatePicker',{attrs:{"allow-past":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }